import { gql } from '@apollo/client';

export const SEARCH_CONTENT = gql`
  query SearchContent($input: ContentSearchInput!) {
    searchContent(input: $input) {
      results {
        id
        eventType
        createdAt
        communityId
        topicName
        contentType
        isSampled
        classificationResults {
          languageDetected
          languageClassified
          wasTranslated
          classificationType
          transcript
          processingTimeMs
          confidenceScore
          executionTimeMs
          categories
          explanation
          labels {
            labelName
            severity
            labelNumMap
            labelShortName
            labelId
            score
            contentType
          }
          policies {
            id
            name
            description
            communityId
            type
            isEnabled
            labels {
              labelId
              severity
            }
            createdBy
            createdAt
            lastModifiedBy
            lastModifiedAt
          }
          nonTriggeredPolicies {
            id
            name
            description
            communityId
            type
            isEnabled
            labels {
              labelId
              severity
            }
            createdBy
            createdAt
            lastModifiedBy
            lastModifiedAt
          }
        }
        contentMetadata {
          subjectId
          audioFileUrl
          contentUrl
          metadata
          subjectOwner {
            type
            id
            additionalInfo
          }
          customValues
        }
      }
      totalCount
      executionTimeMs
      pagination {
        skip
        batchSize
        hasMore
        nextSkip
      }
    }
  }
`;
